import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { searchSchedaSpese, clearSearchResults } from "../../features/schedaSpese/schedaSpeseSlice";

const MIN_CHARS = 3;
const DEBOUNCE_MS = 300;

// Top search bar: min 3 chars before searching, results shown as a styled dropdown.
function SchedaSearchBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchResults, isSearching } = useSelector((state) => state.schedaSpese);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed.length < MIN_CHARS) {
      dispatch(clearSearchResults());
      return;
    }
    const timeoutId = setTimeout(() => {
      dispatch(searchSchedaSpese(trimmed));
    }, DEBOUNCE_MS);
    return () => clearTimeout(timeoutId);
  }, [query, dispatch]);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const handleSelect = (scheda) => {
    navigate(`/note-spese/${scheda.scope}/${scheda._id}`);
    setQuery("");
    setIsOpen(false);
    dispatch(clearSearchResults());
  };

  const trimmedLength = query.trim().length;
  const showDropdown = isOpen && trimmedLength >= MIN_CHARS;

  return (
    <div className="position-relative" ref={containerRef} style={{ width: "100%", maxWidth: "360px" }}>
      <div className="position-relative">
        <FaSearch
          size={13}
          className="position-absolute text-secondary"
          style={{ top: "50%", left: "0.9rem", transform: "translateY(-50%)" }}
        />
        <input
          type="search"
          className="dashboard-input w-100 ps-5"
          style={{ paddingLeft: "2.25rem" }}
          placeholder="Search schede..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setIsOpen(true)}
        />
      </div>

      {showDropdown && (
        <div
          className="position-absolute bg-white rounded-3 shadow mt-1 py-1"
          style={{ top: "100%", left: 0, right: 0, zIndex: 1050, maxHeight: "320px", overflowY: "auto" }}
        >
          {isSearching ? (
            <div className="px-3 py-2 text-secondary text-sm">Searching...</div>
          ) : searchResults.length === 0 ? (
            <div className="px-3 py-2 text-secondary text-sm">No schede found</div>
          ) : (
            searchResults.map((scheda) => (
              <div
                key={scheda._id}
                role="button"
                className="px-3 py-2 text-sm search-result-item"
                onClick={() => handleSelect(scheda)}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span className="text-dark text-truncate">{scheda.titolo}</span>
                  <span className="dashboard-badge ms-2 text-nowrap">
                    {scheda.scope === "personal" ? "Personal" : "Shared"}
                  </span>
                </div>
                {scheda.matchedNote && (
                  <div className="text-secondary text-truncate fst-italic" style={{ fontSize: "0.75rem" }}>
                    note: "{scheda.matchedNote}"
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default SchedaSearchBar;
